import { fetchPCAreasAPI, fetchPCFieldsAPI } from '../../services/wellFilterService';
import { removePCFilter, setPCSelectedAssets, fetchPCWellDetailsThunk } from './WellFilterSlice';

export function buildWellSummaryRequestBody(selectedFilters: { section: string; value: string }[] = []) {
  const getCsv = (sectionNames: string[]) =>
    (selectedFilters || [])
      .filter((f) => sectionNames.includes(f.section))
      .map((f) => f.value)
      .filter(Boolean)
      .join(',');

  return {
    mopCsv: getCsv(['Method of production', 'MOP', 'MethodOfProduction']),
    businessUnitCsv: getCsv(['Business unit', 'BusinessUnit']),
    fieldCsv: getCsv(['Field']),
    groupCsv: getCsv(['Groups', 'Group', 'Asset Group']),
  };
}

export const getFilterIdsArr = (filters: any[], section: string) =>
  filters.filter((f: any) => f.section === section && typeof f.id === 'number').map((f: any) => f.id);

export const handleRemoveFilter = (filter: any, selectedFilters: any[], dispatch: any): void => {
  dispatch(removePCFilter(filter));

  let updatedFilters;
  if (filter === 'ALL') {
    updatedFilters = [];
  } else {
    updatedFilters = selectedFilters.filter((f: any) => !(f.section === filter.section && f.value === filter.value));
  }

  const selectedBUs = getFilterIdsArr(updatedFilters, 'Business unit');
  const selectedAreas = getFilterIdsArr(updatedFilters, 'Area');

  if (filter.section === 'Business unit' || filter === 'ALL') {
    if (selectedBUs.length === 0) {
      dispatch(fetchPCAreasAPI());
    } else {
      dispatch(fetchPCAreasAPI(selectedBUs));
    }
    dispatch(fetchPCFieldsAPI({ businessUnitIds: selectedBUs, areaIds: selectedAreas }));
  }

  if (filter.section === 'Area' || filter === 'ALL') {
    dispatch(fetchPCFieldsAPI({ businessUnitIds: selectedBUs, areaIds: selectedAreas }));
  }

  // Handle Asset filter removal
  if (filter.section === 'Assets' || filter === 'ALL') {
    const remainingAssetFilters = updatedFilters.filter((f: any) => f.section === 'Assets');
    const remainingAssetIds = remainingAssetFilters.map((f: any) => f.id as string).filter(Boolean);

    dispatch(setPCSelectedAssets(remainingAssetIds));

    if (remainingAssetIds.length > 0) {
      dispatch(fetchPCWellDetailsThunk(remainingAssetIds));
    } else {
      dispatch(fetchPCWellDetailsThunk([]));
    }
  }
};
